import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/orders`;

export const commonapiService = {

    getCategories,
    getCountry,
    getConfigData,

};

function getCategories() {
    return fetchWrapper.get(`${process.env.REACT_APP_API_URL}/tama-categories/dropdown`);
}
function getCountry() {
    return fetchWrapper.get(`${process.env.REACT_APP_API_URL}/ref/countries`);
}
function getConfigData() {
    return fetchWrapper.get(`${process.env.REACT_APP_API_URL}/getCategories`);
}


